import Map from "@/utils/Map";
import Map_DynamicElementGeometry from "@/utils/map/Map_DynamicElementGeometry";
import * as egm96 from "egm96-universal";
import { v4 as uuidv4 } from "uuid";
import { Category_Elems, MapElementType, InfosDraw, } from "@/utils/constant/settings_constantes";
// import { ContentSteeringController } from "hls.js";

export default class Map_DynamicElement {
  viewer;
  app;
  datasource;
  pickActive;
  pickedInfos;
  lstCatVisible;
  timerMouse;
  timerMouseTime;
  lastEventMouseMove;

  constructor(viewer, app) {
    this.viewer = viewer;
    this.app = app;
    this.datasource = undefined;
    this.pickActive = true;
    this.pickedInfos = {
      element: "",
      position: undefined,
      clicRight: false,
      clicLeft: false,
      leftDown : false,
      isInsert: false,
      wheel :0,
      endPosition: undefined,
    };
    this.lstCatVisible = [];
    this.timerMouse = undefined;
    this.timerMouseTime = 100;
    this.lastEventMouseMove = undefined;
    this.init();
  }

  init() {
    this.datasource = new Cesium.CustomDataSource("MapDynamicElements");
    this.viewer.dataSources.add(this.datasource);
    this.datasource.entities.collectionChanged.addEventListener(() => {
      this.calcNbElements();
    });

    this.initEvents();
    let mapfilter = $root.user.getMapFilter();

    Category_Elems.forEach((cat) => {
      if (mapfilter[cat.key] !== undefined) {
        cat.checked = mapfilter[cat.key];
      }

      if (cat?.children) {
        cat.children.forEach((subcat) => {
          if (mapfilter[subcat.key] !== undefined) {
            subcat.checked = mapfilter[subcat.key];
          }

          if (subcat.checked) this.lstCatVisible.push(subcat.key);
        });
      }
    });
  }

  clear() {
    this.datasource.entities.removeAll();
  }

  enablePick(isEnable) {
    this.pickActive = isEnable;
  }

  dispatchEvent() {
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic && entity.dynamic.update !== undefined) {
        entity.dynamic.update(
          this.pickedInfos,
          Map.isCustomElementOpen(entity.dynamic)
        );
      }
    });
    this.pickedInfos.clicRight = false;
    this.pickedInfos.clicLeft = false;
  }

  cancel() {
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic && entity.dynamic.update !== undefined) {
        entity.dynamic.cancel();
      }
    });
    this.viewer.canvas.style.cursor = "";
    this.pickedInfos.element = "";
    this.pickedInfos.isInsert = false;
    this.pickedInfos.clicRight = false;
    this.pickedInfos.clicLeft = false;
  }

  isSameCoord(coorda, coordb) {
    if (
      coorda.latitude !== coordb.latitude ||
      coorda.longitude !== coordb.longitude ||
      coorda.height !== coordb.height
    ) {
      return false;
    }
    return true;
  }

  addDynamic(coords, type, id, name, active, color, size, callbackEdit) {
    let dynamicElement = undefined;
    let entity = this.getById(id);

    if (entity !== null) {
      dynamicElement = entity.dynamic;
      dynamicElement.setGeom(coords);
      dynamicElement.setActive(active);
      dynamicElement.setColor(color);
      dynamicElement.setAlpha(type === MapElementType.Point ? 0.8 : 0.6);
      dynamicElement.setName(name);
      dynamicElement.setSize(size);

      dynamicElement.events.updateCustomMapElement();
    }
    else {
      dynamicElement = new Map_DynamicElementGeometry(
        this.viewer,
        this.datasource,
        () => {},
        this.isTypeVisible.bind(this),
      );
      dynamicElement.setType(type);
      dynamicElement.setAbsolute(type === MapElementType.Point);
      dynamicElement.setGeom(coords);
      dynamicElement.setActive(active);
      dynamicElement.setColor(color);
      dynamicElement.setAlpha(type === MapElementType.Point ? 0.8 : 0.6);
      dynamicElement.setSize(size);
      dynamicElement.setName(name);
      dynamicElement.setId(id);

      let entity = undefined;

      if (type === MapElementType.Point) {
        entity = dynamicElement.point.getEntityPoint();
      } else if (type === MapElementType.Polygone) {
        entity = dynamicElement.polygon.getEntityPolygon();
      } else if (type === MapElementType.Ligne) {
        entity = dynamicElement.line.getEntityLine();
      }
      // entity.dynamic = dynamicElement;
      entity.show = dynamicElement.getVisibility();

      entity.customId = '__mapElements__' + id
      entity.customType = type;
      this.datasource.entities.add(entity);


    }
  }

  insertDynamic(type) {
    const uid = uuidv4();
    var _entity = undefined;
    this.setCursor("copy");
    this.pickedInfos.clicLeft = false;
    let dynamicElement = new Map_DynamicElementGeometry(
      this.viewer,
      this.datasource,
      (IsCanceled) => {
        // console.log("finish");
        this.setCursor("");
        this.app.catDrawingCurrent = "";
        this.pickedInfos.isInsert = false;

        if (IsCanceled) {
          dynamicElement.events.setInfosDrawHelp(InfosDraw.Cancel);
          dynamicElement.setActive(false);
          this.removeById(uid);
        } else if (dynamicElement.infos.name === "") {
          //new Element
          dynamicElement.setAbsolute(type === MapElementType.Point);
          dynamicElement.events.showMapElement();

          setTimeout(() => {
            _entity.customType = type;
            _entity.customId = '__mapElements__' + dynamicElement.infos.id;
            this.setCursor("");
          }, 1000);
        }
      },
      this.isTypeVisible.bind(this),
    );

    dynamicElement.setAbsolute(false);
    dynamicElement.setHeight(50);
    dynamicElement.setId(uid);
    dynamicElement.setType(type);
    dynamicElement.setColor("#FFFFFF");
    dynamicElement.setAlpha(0.5);
    dynamicElement.setSize(50);
    dynamicElement.setActive(true);
    let entity = undefined;
    if (type === MapElementType.Point) {
      entity = dynamicElement.point.getEntityPoint();
    } else if (type === MapElementType.Polygone) {
      entity = dynamicElement.polygon.getEntityPolygon();
    } else if (type === MapElementType.Ligne) {
      entity = dynamicElement.line.getEntityLine();
    }

    _entity = this.datasource.entities.add(entity);

    this.pickedInfos.element = uid;
    this.pickedInfos.isInsert = true;
    dynamicElement.events.setInfosDrawHelp(InfosDraw.Start);
  }

  getDatasource() {
    return this.datasource;
  }

  getPickedInfos() {
    return this.pickedInfos;
  }

  getAllName() {
    let allNames = [];
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        allNames.push(entity.dynamic.getName());
      }
    });
    return allNames;
  }

  getAllId() {
    let allIds = [];
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        allIds.push(entity.dynamic.getId());
      }
    });
    return allIds;
  }

  getByName(name) {
    let element = null;
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        if (entity.dynamic.getName() === name) {
          element = entity;
        }
      }
    });
    return element;
  }

  getById(id) {
    let element = null;
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        if (entity.dynamic.getId() === id) {
          element = entity;
        }
      }
    });
    return element;
  }

  removeByName(name) {
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        if (entity.dynamic.getName() === name) {
          entity.dynamic.controlspointsEntities.forEach(
            (controlspointsEntitie) => {
              this.datasource.entities.remove(controlspointsEntitie);
            }
          );
          entity.dynamic = null;
          this.datasource.entities.remove(entity);
        }
      }
    });
  }

  removeById(id) {
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        if (
          entity.dynamic.getId() === id &&
          entity.dynamic.events.isInsert() === false
        ) {
          entity.dynamic.controlspointsEntities.forEach(
            (controlspointsEntitie) => {
              this.datasource.entities.remove(controlspointsEntitie);
            }
          );
          entity.dynamic = null;
          this.datasource.entities.remove(entity);
        }
      }
    });
  }

  removePoint(id, index) {
    let entity = this.getById(id);
    if (entity !== null) {
      entity.dynamic.polygon.removePointToPoly(index);
      Map.toggle_popup_contextmenu(false);
    }
  }

  pickEntiy(position) {
    const pickedObject = this.viewer.scene.pick(position);
    return pickedObject;
  }

  pickPosition(position) {
    this.datasource.show = false;
    //this.viewer.scene.render();
    const cartesian = this.viewer.scene.pickPosition(position);
    this.datasource.show = true;
    return cartesian;
  }

  tryPick(position) {
    let cartesian = this.pickPosition(position);
    if (Cesium.defined(cartesian)) {
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      //// console.log("tryPick "  + cartographic);
      if (cartographic.height < 0) {
        cartesian = undefined;
      }
    }
    else {
      cartesian = Map.pickTerrain(position);
    }
    return cartesian;
  }

  /*pickTerrain(position) {
    const ray = this.viewer.scene.camera.getPickRay(position);
    const cartesian = this.viewer.scene.globe.pick(ray, this.viewer.scene);
    return cartesian;
  }*/

  setCursor(cursor) {
    this.viewer.canvas.style.cursor = cursor;
  }

  initEvents() {

    this.timerMouse = setInterval(() => {
      if(this.lastEventMouseMove !== undefined){
        this.mouseMove(this.lastEventMouseMove);
        this.lastEventMouseMove = undefined;
      }
    }, this.timerMouseTime);

    let handler = new Cesium.ScreenSpaceEventHandler(this.viewer.canvas);
    handler.setInputAction((event) => {

      this.lastEventMouseMove = event;

    }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

    handler.setInputAction((event) => {
      this.viewer.selectedEntity = undefined;
      this.pickedInfos.clicRight = true;
      this.dispatchEvent();
    }, Cesium.ScreenSpaceEventType.RIGHT_CLICK);

    handler.setInputAction((event) => {
      this.viewer.selectedEntity = undefined;
      this.pickedInfos.clicLeft = true;
      if (this.pickedInfos.isInsert === false) {
        if (this.pickedInfos.element !== "") {
          let entity = this.getById(this.pickedInfos.element);
          if (entity !== null) {
            if (entity.dynamic.infos.name !== "") {
              //existant
              entity.dynamic.events.showMapElement();
            }
          }
        } else {
          Map.toggle_popup_contextmenu(false);
        }
      }
      this.dispatchEvent();
    }, Cesium.ScreenSpaceEventType.LEFT_CLICK);

    handler.setInputAction((event) => {
      this.viewer.selectedEntity = undefined;
      this.pickedInfos.leftDown = true;
      this.dispatchEvent();
    }, Cesium.ScreenSpaceEventType.LEFT_DOWN);

    handler.setInputAction((event) => {
      this.viewer.selectedEntity = undefined;
      this.pickedInfos.leftDown = false;
      this.dispatchEvent();
    }, Cesium.ScreenSpaceEventType.LEFT_UP);

    handler.setInputAction((wheel) => {
      this.pickedInfos.wheel = wheel > 0 ? 1 : -1;
    }, Cesium.ScreenSpaceEventType.WHEEL);
  }

  mouseMove(event) {
    this.pickedInfos.endPosition = event.endPosition;
    if (this.pickActive && this.pickedInfos.isInsert === false && $root.global.flightedit.defineTakeoff === false) {

      const pickedObject = this.pickEntiy(event.endPosition);
      if (Cesium.defined(pickedObject) && pickedObject.id) {
        if (pickedObject.id.dynamic) {
          this.pickedInfos.element = pickedObject.id.dynamic.infos.id;
          this.setCursor("copy");
        }
        if(pickedObject.id === "frustum") {
          //frustum
          this.pickedInfos.element = pickedObject.id;
        }
      } else {
        this.pickedInfos.element = "";
        this.setCursor("");
      }
    }

    const cartesian = this.tryPick(event.endPosition);
    if (Cesium.defined(cartesian)) {
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);

      if (Cesium.defined(cartographic) && cartographic.height >= 0) {
        this.pickedInfos.position = new Cesium.Cartographic(
          Cesium.Math.toDegrees(cartographic.longitude),
          Cesium.Math.toDegrees(cartographic.latitude),
          cartographic.height
        );
        //// console.log(cartographic);
        this.dispatchEvent();

        // barre information
        let height = cartographic.height;
        let asl = egm96.ellipsoidToEgm96(
          Cesium.Math.toDegrees(cartographic.latitude),
          Cesium.Math.toDegrees(cartographic.longitude),
          height
        );
        if (
          cartographic.height < 0 ||
          this.viewer.camera.positionCartographic.height > 100000
        ) {
          height = 0;
          asl = 0;
        }
        const info = {
          lat: Cesium.Math.toDegrees(cartographic.latitude).toFixed(6),
          lng: Cesium.Math.toDegrees(cartographic.longitude).toFixed(6),
          wgs: height.toFixed(1),
          asl: asl.toFixed(1),
        };
        Map.setInfosCameraPos(info);
      } else {
        Map.setInfosCameraPos(null);
      }
    } else {
      Map.setInfosCameraPos(null);
    }
  }

  updateLstVisible(classeElement, isVisible) {
    if (isVisible && this.lstCatVisible.indexOf(classeElement) === -1) {
      this.lstCatVisible.push(classeElement);
    } else if (!isVisible && this.lstCatVisible.indexOf(classeElement) > -1) {
      this.lstCatVisible.splice(this.lstCatVisible.indexOf(classeElement), 1);
    }

    this.forceRefresh();
  }

  isTypeVisible(type) {
    const idx = this.lstCatVisible.indexOf(type);
    return idx === -1 ? false : true;
  }

  calcNbElements() {
    let nb_pts = 0;
    let nb_lines = 0;
    let nb_poly = 0;

    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        if (entity.dynamic.getType() === MapElementType.Point) {
          nb_pts++;
        } else if (entity.dynamic.getType() === MapElementType.Ligne) {
          nb_lines++;
        } else if (entity.dynamic.getType() === MapElementType.Polygone) {
          nb_poly++;
        }
      }
    });

    $root.global.statsDynamicElements = {
      Point: nb_pts,
      Ligne: nb_lines,
      Polygone: nb_poly,
    };
  }

  forceRefresh() {
    this.datasource.entities.values.forEach((entity) => {
      if (entity.dynamic) {
        // entity.dynamic.forceUpdateInfos(true)
        entity.dynamic.datasource.entities._entities._array.map(el => {
          if (el._customType) {
            el.show = this.isTypeVisible(el._customType);
          }
        })
      }
    });

    console.log(this.datasource);
  }
}
